<template>
  <div class="flex flex-col bg-white desktop-height h-full">
    <div class="flex-shrink-0">
      <slot name="header"></slot>
    </div>
    <div class="flex-1 flex flex-col min-h-0 overflow-y-auto">
      <slot></slot>
    </div>
    <div v-if="buttons && buttons.length" class="px-4 pb-6 pt-2 flex-shrink-0">
      <div class="flex gap-3">
        <template v-for="btn in buttons">
          <CuButton
            :key="btn.text"
            :primary="btn.primary"
            :secondary="btn.secondary"
            :dark="btn.dark"
            :class="btn.class"
            :disabled="btn.disabled"
            class="flex-1"
            @click="btn.onClick"
          >
            {{ btn.text }}
          </CuButton>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import CuButton from './cu/CuButton.vue'

export default {
  name: "CuWizard",
  components: { CuButton },
  props: {
    buttons: {
      type: Array,
      default: () => []
    }
  }
}
</script>


<style scoped>
/* on desktop, desktop-height must be 80vh of min height */
@media (min-width: 1024px) {
  .desktop-height {
    min-height: 80vh;
  }
}
</style>